<template lang="html">
    <div class="join">
        <div class="banner-img">
            <img width="100%" src="https://static.qyjmed.com/webSite/contactUs/join/banner.png" alt="">
        </div>
        <div class="content">
            <div class="container">
                <div class="join-tab">
                    <ul>
                        <li>
                            <div @click="shows=1,show1=true" >
                                <p :class="{active:show1==true}">全部（3）</p>
                            </div>
                        </li>
                        <li>
                            <div @click="shows=2,show1=false" >
                                <p :class="{active:shows==2}">销售</p>
                            </div>
                        </li>
                        <li>
                            <div @click="shows=3,show1=false" >
                                <p :class="{active:shows==3}">采购专员</p>
                            </div>
                        </li>
                        <li>
                            <div @click="shows=4,show1=false" >
                                <p :class="{active:shows==4}">工程师</p>
                            </div>
                        </li>

                    </ul>
                </div>
                <div class="join-list">
                    <ul>
                        <li v-show="show1 || shows==2">
                            <div>
                                <h2>销售</h2>
                                <hr>
                                <div class="join-box">
                                    <div class="join-detail">
                                        <h3>职位描述</h3>
                                        <ol>
                                            <li>
                                                <p>对接医院,完成相关区域内医院的医疗设备售后的全院托管,科室托管 ,设备维护托管等服务。</p>
                                            </li>
                                            <li>
                                                <p>负责区域市场开发</p>
                                            </li>
                                            <li>
                                                <p>负责完成区域销售任务</p>
                                            </li>
                                            <li>
                                                <p>收集客户资料并维护客户关系</p>
                                            </li>
                                            <li>
                                                <p>根据公司的销售政策,不断调整并配合本区域营销活动</p>
                                            </li>
                                            <li>
                                                <p>定期拜访客户,并对客户进行分类整理归档</p>
                                            </li>
                                        </ol>
                                    </div>
                                    <div class="join-require">
                                        <h3>任职要求</h3>
                                        <ol>
                                            <li>
                                                <p>较强的学习能力,沟通能力,思路清晰敏捷</p>
                                            </li>
                                            <li>
                                                <p>一定的抗压能力 ,适应出差。</p>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                                <p>只要你有能力,我们就有给你展现能力的舞台。</p>
                                <p>简历投递邮箱：hr@qyjmed.com</p>
                            </div>
                        </li>
                        <li v-show="show1 ||  shows==3">
                            <div>
                                <h2>采购专员</h2>
                                <hr>
                                <div class="join-box">
                                    <div class="join-detail">
                                        <h3>职位描述</h3>
                                        <ol>
                                            <li>
                                                <p>执行采购订单和采购合同，落实具体采购流程</p>
                                            </li>
                                            <li>
                                                <p>负责采购订单制作、确认、安排发货及跟踪到货日期</p>
                                            </li>
                                            <li>
                                                <p>执行并完善成本降低及控制方案</p>
                                            </li>
                                            <li>
                                                <p>开发、评审、管理供应商，维护与其关系</p>
                                            </li>
                                            <li>
                                                <p>填写有关采购表格，提交采购分析和总结报告</p>
                                            </li>
                                            <li>
                                                <p>完成采购主管安排的其它工作</p>
                                            </li>
                                        </ol>
                                    </div>
                                    <div class="join-require">
                                        <h3>任职要求</h3>
                                        <ol>
                                            <li>
                                                <p>大专及以上学历；英语四级以上</p>
                                            </li>
                                            <li>
                                                <p>有医疗设备采购或者医疗维修采购工作经验者优先</p>
                                            </li>
                                            <li>
                                                <p>熟悉采购流程，良好的沟通能力、谈判能力和成本意识</p>
                                            </li>
                                            <li>
                                                <p>工作细致认真，责任心强，思维敏捷，具有较强的团队合作精神</p>
                                            </li>
                                            <li>
                                                <p>有良好的职业道德和素养，能承受一定工作压力</p>
                                            </li>
                                            <li>
                                                <p>熟练使用Word, excel等办公软件</p>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                                <p>我们的采购不是简单的下单，要比较价格、跟进订单，要能够拿捏分寸、要具备很强的沟通能力。</p>
                                <p>我们希望员工：踏实、能干、聪明、自信，具有较高的综合素质！</p>
                                <!-- <p>我们提供一个公平合理，且极具发展前景的平台给我们的员工施展。</p> -->
                                <p>简历投递邮箱：hr@qyjmed.com</p>
                            </div>
                        </li>
                        <li v-show="show1 ||  shows==4">
                            <div>
                                <h2>工程师</h2>
                                <hr>
                                <div class="join-box">
                                    <div class="join-detail">
                                        <h3>职位描述</h3>
                                        <ol>
                                            <li>
                                                <p>负责医院医疗西设备的维修和保养,做到及时响应如: CT、心电图等; </p>
                                            </li>
                                            <li>
                                                <p>做好设备的维修记录、建立维修档案;</p>
                                            </li>
                                            <li>
                                                <p>提高技术业务水平,不断学习,不定期参加培训,提高自修率。</p>
                                            </li>
                                            <li>
                                                <p>负责客户的维护,定期对设备维修情况进行跟踪回访;</p>
                                            </li>
                                            <li>
                                                <p>为医院故障设备提出合理的维修方案;</p>
                                            </li>
                                            <li>
                                                <p>在规定时间内到达维修现场,对故障进行检测、维修,保证医院设备正常使用;</p>
                                            </li>
                                            <li>
                                                <p>配合公司客服部和采购部做好设备的故障初步评判</p>
                                            </li>
                                            <li>
                                                <p>树立公司良好的企业形象,对公司商业秘密做到保密,不得损害公司利益。</p>
                                            </li>
                                        </ol>
                                    </div>
                                    <div class="join-require">
                                        <h3>任职要求</h3>
                                        <ol>
                                            <li>
                                                <p>有3-5年CT类维修或者是售后服务经验</p>
                                            </li>
                                            <li>
                                                <p>有全科维修经验优先考虑</p>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                                <p>我们的工程师只要你来，我们就给你最好的发展平台</p>
                                <p>简历投递邮箱：hr@qyjmed.com</p>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
export default {
  name: 'HeaderTop',
  data(){
      return{
          shows: 0,
          show1:true
      }
  },
  methods:{

  },
  components: {
      Foot
  }
}
</script>

<style lang="scss" scoped>
hr{
    background-color: #dadada;
    border: none;
    height: 1px;
}
    .join{
        .banner-img{
            margin-top: $highlight-height;
        }
        .content{
            .join-tab{
                ul{
                    text-align: center;
                    margin:40px 0 64px;
                    li{
                        width: 150px;
                        display: inline-block;
                        height: 56px;
                        background: #F4F4F4;
                        margin-right: 50px;
                        margin-top: 20px;
                        div{

                            cursor: pointer;
                            p{
                                font-size: 22px;
                                color: #0C031E;
                                line-height: 56px;
                                &.active{
                                    background: #000000;
                                    color: white;
                                }
                            }
                            // &:hover{
                            //     background: #000000;
                            //     p{
                            //         color: white;
                            //     }
                            // }
                        }
                    }
                }
            }
            .join-list{
                ul{
                    li{
                        >div{
                            margin-bottom: 40px;
                            background: #F5F5F5;
                            width: 1100px;
                            padding: 0 50px;
                            h2{
                                text-align: center;
                                line-height: 68px;
                                color: #000;
                                font-size: 28px;
                                font-weight: 400;
                            }
                            div.join-box{
                                padding:30px 40px 40px;
                                .join-detail,.join-require{
                                    margin-right: 10%;
                                    width: 50%;
                                    display: inline-block;
                                    vertical-align: top;
                                    h3{
                                        margin-bottom: 20px;
                                        font-weight: 400;
                                    }
                                    ol{
                                        color: #666;
                                        font-size: 14px;
                                        li{
                                            margin-left: 20px;
                                            p{
                                                width: 400px;
                                                font-size: 14px;
                                                line-height: 32px;
                                                color: #666666;
                                            }

                                        }
                                    }
                                }
                                .join-require{
                                    width: 40%;
                                    margin-right: 0;
                                }
                            }
                            >p{
                                text-align: center;
                                padding-bottom: 20px;
                                color: #000000;
                                &:last-child{
                                    color: #4BA0FF;
                                    padding-bottom: 42px;
                                }
                            }

                        }
                    }
                }
            }
        }
    }
</style>
